import type { SerializeFrom } from '@remix-run/node'
import type { loader as productsLoader } from '../index.tsx'
import type { loader as productLoader } from '../$slug/index.tsx'
import type { Strain } from '../types.ts'
import { Link, useParams } from '@remix-run/react'
import { Card } from '#app/components/ui/card.tsx'
import { Icon } from '#app/components/ui/icon.tsx'

type Product =
	| SerializeFrom<typeof productsLoader>['products'][number]
	| SerializeFrom<typeof productLoader>['relatedProducts'][number]

export default function ProductCard({ product }: { product: Product }) {
	const { location } = useParams()
	//console.log(product)

	// Generate product link
	const productLink = `${location ? `/${location}` : ''}/products/${
		product?.leafProductMetadata?.slug &&
		product?.leafProductMetadata?.slug !== ''
			? product.leafProductMetadata.slug
			: product.internalId
	}`

	// Check for own images first, then parent images
	const hasOwnImages = product.images && product.images.length >= 1
	const hasParentImages = (product as any).parentImages?.length >= 1
	const imageToUse = hasOwnImages
		? product.images[0]?.image
		: hasParentImages
			? (product as any).parentImages[0]?.image
			: null

	return (
		<div>
			<Card className="group h-full rounded-lg p-0 shadow-md transition-all duration-300 ease-in-out hover:shadow-xl">
				<Link
					to={productLink}
					prefetch="intent"
					className="flex h-full flex-col justify-between"
				>
					{imageToUse ? (
						<img
							src={imageToUse}
							alt={product.display_name ?? ''}
							className="h-60 w-full rounded-md rounded-b-none object-cover"
						/>
					) : (
						<div className="flex h-60 w-full items-center justify-center rounded-md bg-gray-100">
							<p className="text-gray-400">
								<Icon name="image" className="h-8 w-8" />
							</p>
						</div>
					)}

					<div className="flex flex-1 flex-col space-y-2 p-4">
						<p className="mb-2">{product.display_name}</p>
						<div className="flex flex-1 flex-col items-center justify-end">
							<div className="flex w-full justify-between">
								<p className="text-sm capitalize text-primary/50">
									{(product.strains?.[0] as Strain)?.name ?? ''}
								</p>
								{product.leafProductCategory && (
									<span className="text-sm capitalize text-primary/50">
										{product.leafProductCategory.name}
									</span>
								)}
							</div>
						</div>
					</div>
				</Link>
			</Card>
		</div>
	)
}
